<template>
  <div class="content">
    <div class="rightBox">
      <!-- 课程标题 -->
      <div class="rightBox-1">
        <el-image class="cover" :src="courseDetails.cover" />
        <div>
          <h3>{{ courseDetails.name }}</h3>
          <span>{{ courseDetails.description }}</span>
          <!-- 授课老师展示 -->
          <div class="showTeacher">
            <div
              v-for="teacher in courseDetails.teachers"
              :key="teacher.id"
              class="teacher"
            >
              <img class="img" :src="teacher.headpic" />
              <div>
                <span>{{ teacher.name }}</span
                ><span>{{ teacher.prefix }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 课程目录 -->
      <div
        v-for="(item_list, index) in list"
        :key="index"
        class="course_section"
      >
        <div v-if="item_list.id > 0" class="course_name">
          <span v-if="item_list.ident" style="margin-right: 10px">{{
            item_list.ident
          }}</span
          >{{ item_list.name }}
        </div>
        <div ref="subjectList" class="subjectList">
          <el-collapse
            v-for="(item, cindex) in item_list.chapters"
            :key="cindex"
            v-model="activeName"
            @change="collapseChange"
          >
            <el-collapse-item
              :disabled="item.attachs.length == 0 || listShowTaggle"
              :name="item.id"
            >
              <template slot="title">
                <!--原有样式 -->
                <div class="item">
                  <div class="item-right">
                    <div class="item-2" :class="{ lock: item.is_lock === 1 }">
                      <div class="item-2-left">
                        <div class="left_cotent">
                          <div v-if="item.ident" class="chapter-ident">
                            {{ item.ident }}
                          </div>

                          <div>
                            <div class="title">{{ item.title }}</div>
                            <div class="others">
                              <span v-if="item.video_second_show">{{
                                item.video_second_show
                              }}</span>
                              <span
                                v-if="
                                  item.is_lock === 1 && item.start_time_show
                                "
                                >{{ item.start_time_show }} 开课</span
                              >
                              <span v-if="item.is_lock === 0"
                                >{{
                                  item.learn_log.progress === 0
                                    ? '未学习'
                                    : item.learn_log.progress >= 98
                                    ? '已学完'
                                    : `已学${item.learn_log.progress}%`
                                }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <!-- 右边按钮区 -->
                        <div class="right_button">
                          <div v-if="item.is_lock" class="lock">
                            <icon-svg icon-class="suoding" />
                          </div>
                          <div v-else>
                            <el-button
                              v-if="item.attachs.length > 0"
                              size="mini"
                              type="primary"
                              @click="filesListShow"
                              >课件资料</el-button
                            >
                            <el-button
                              plain
                              size="mini"
                              type="primary"
                              @click="chapterPlay(item)"
                              ><icon-svg
                                icon-class="bofang"
                                style="margin-right: 2px"
                              />播放</el-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div class="itemContent">
                <div
                  v-for="(text, h) in item.attachs"
                  :key="h"
                  class="contentText"
                >
                  <span :title="text.title">{{ text.title }}</span>
                  <span>{{ size(text.size) }}</span>
                  <el-button
                    v-if="text.can_down !== 0"
                    @click="getInfo(item.id, text.id)"
                  >
                    下载
                  </el-button>
                  <el-button v-else class="cur">
                    <icon-svg icon-class="suoding" />
                  </el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubjectDetails, getSubjectInfo } from '@/network/request'
import { getSectionWithChapter } from '@/api/course'
import { mapMutations } from 'vuex'
export default {
  name: 'CourseTable',
  components: {},
  props: {},
  data() {
    return {
      course_id: this.$route.params.id, // 传过来的课程id
      collSection: [], // 折叠面板 当前展开的大纲，非当前选中小节的大纲
      courseDetails: {}, // 课程详情
      list: [],
      activeName: 1,
      listShowTaggle: true,
    }
  },
  computed: {
    // 换算单位
    size() {
      return (i) => {
        const kb = i / 1024
        if (kb < 1024) {
          return `${Math.round(kb)} KB`
        } else {
          return `${Math.round(kb / 1024)} MB`
        }
      }
    },
  },
  mounted() {
    // 接收传过来的id
    this.getSubjectDetails()
    this.getlist()
  },
  methods: {
    ...mapMutations(['SET_SECTIONADCHAPTER']),
    //按钮事件使能，并通过冒泡打开列表
    filesListShow() {
      this.listShowTaggle = false
    },
    //change事件失能
    collapseChange() {
      this.listShowTaggle = true
    },
    // 获取课程详情
    async getSubjectDetails() {
      const res = await getSubjectDetails(this.course_id, true)
      this.courseDetails = res.data.result
    },

    // 课程点击
    chapterPlay(chapter) {
      this.$router.push({
        name: 'courseCatalogue',
        params: {
          id: chapter.course_id,
        },
        query: {
          chapter_id: chapter.id,
        },
      })
    },
    //获取大纲、小节、课件文件
    async getlist() {
      const { data } = await getSectionWithChapter({
        course_id: this.course_id,
      })
      if (data.code === 0) {
        this.list = data.result
      }
      //小节信息
      console.log(data.result)
      this.SET_SECTIONADCHAPTER(this.list)
    },
    //下载
    async getInfo(chapterId, attachId) {
      const res = await getSubjectInfo({
        chapter_id: chapterId,
        attach_id: attachId,
      })
      this.subjectInfo = res.data.result
      location.href = res.data.result.object.down_url // 下载文件
    },
  },
}
</script>
<style scoped>
::v-deep(.tcp-vtt-thumbnail-img) {
  width: unset !important;
  height: unset !important;
}
</style>
<style lang="scss" scoped>
.changeBlue {
  color: #419cff !important;
}

.changeBlueBox::before {
  background-color: #419cff !important;
}

.el-icon-s-claim:before {
  color: #419cff;
}

.ifnull {
  margin-bottom: 20px;
  font-size: 12px;
  color: rgb(23, 184, 130);
}

.content {
  display: flex;
  width: 960px;
  margin: 0 auto;
  padding: 30px 20px 30px 20px;
  min-height: calc(100vh - 67px - 112px);

  .rightBox {
    width: 100%;

    .course_section {
      margin-bottom: 20px;
    }
    .course_name {
      padding: 20px 30px;
      font-size: 18px;
      font-weight: 600;
      color: #141414;
      background: #fff;
      border-bottom: 1px solid #eee;
    }

    // 课程简介
    .rightBox-1 {
      background-color: #ffffff;
      border-radius: 4px;
      padding: 30px 30px;
      margin-bottom: 20px;
      overflow: hidden;
      display: flex;

      .cover {
        display: block;
        width: 200px;
        height: 138px;
        margin-right: 30px;
        border-radius: 5px;
      }

      h3 {
        font-size: 20px;
        font-weight: normal;
        color: #141414;
        margin-bottom: 14px;
      }

      span {
        font-size: 13px;
        color: #999999;
      }

      .showTeacher {
        display: flex;
        margin-top: 20px;

        .teacher {
          display: flex;
          align-items: center;
          margin-right: 20px;
          margin-top: 20px;

          background: #fafcff;
          border-radius: 6px;
          padding: 5px 10px;

          .img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border-radius: 50%;
          }

          div:nth-child(1) {
            width: 29px;
            height: 29px;
            background-color: #d8d8d8;
            border-radius: 50%;
            margin-right: 8px;
            overflow: hidden;
          }

          div:nth-child(2) {
            display: flex;
            flex-direction: column;

            span:nth-child(1) {
              font-size: 13px;
              color: #666666;
              margin-bottom: 5px;
            }

            span:nth-child(2) {
              font-size: 10px;
              color: #999999;
            }
          }
        }
      }
    }

    //   课程目录

    .subjectList {
      background-color: #ffffff;
      border-radius: 4px;
      // min-height: calc(100vh - 489px);

      .el-collapse {
        border: 0;

        ::v-deep(.el-collapse-item) {
          .el-collapse-item__header {
            cursor: default;
            height: auto;
            font-size: 17px;
            color: #141414;

            &.is-active {
              background-color: #ffffff;
            }
          }

          .el-collapse-item__arrow {
            display: none;
          }

          .el-collapse-item__content {
            padding-bottom: 0;
            padding: 0 30px;
          }
        }
        border-bottom: 1px solid #eee;

        &:last-child {
          border-bottom: 0;
        }
      }

      .item {
        width: 100%;

        .item-2 {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 18px 30px 18px 30px;
          line-height: 1.7;
          width: 100%;
          // background-color: #141414;

          &.lock {
            span {
              color: #999999 !important;
            }
          }

          .item-2-left {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .left_cotent {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .chapter-ident {
                margin-right: 20px;
                font-weight: 600;
                font-size: 14px;
              }

              margin-right: 30px;

              .title {
                font-size: 16px;
                font-weight: 500;
                color: #141414;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-bottom: 5px;
              }

              .others {
                font-size: 14px;
                color: #999999;

                > span {
                  margin-right: 10px;
                }
              }
            }
          }

          .right_button {
            display: flex;
            justify-content: space-around;
            align-items: center;

            .el-button {
              margin-right: 10px;
              text-align: center;

              border: none;
              margin-bottom: 3px;
              margin-right: 0;
            }
            .lock {
              color: #9a9a9a;
            }
          }
        }
      }

      .itemContent {
        padding: 14px 20px;
        // border-top: 1px solid #eee;
        background: #fafcff;
        margin-bottom: 30px;
        margin-top: 10px;
        border-radius: 6px;

        .contentText {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
          font-size: 15px;
          color: #666666;

          span:first-child {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span:nth-child(2) {
            width: 80px;
            text-align: center;
            margin-right: 60px;
            margin-left: 50px;
          }

          .el-button {
            background: none;
            padding: 0;
            width: 60px;
            height: 28px;
            line-height: 28px;
            color: #666;
            font-weight: 400;
          }
        }

        .contentText:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
